// Angular imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Third-party libraries
import { SkeletonModule } from '@openng/optimus-ui/skeleton';
import { SelectModule } from '@openng/optimus-ui/select';

// Project libraries
import { ComponentsModule } from '@tgx/shared/ui/components';
import { SharedUiStorybookModule } from '@tgx/shared/ui/storybook';

// Local components
import { OnboardingCompanyComponent } from './onboarding-company.component';
import { OnboardingCompanyRoutingModule } from './onboarding-company-routing.module';
import { OnboardingCompanyBillingComponent } from './components/onboarding-company-billing/onboarding-company-billing.component';
import { OnboardingCompanyCompanyContactsComponent } from './components/onboarding-company-company-contacts/onboarding-company-company-contacts.component';
import { OnboardingCompanyFinishComponent } from './components/onboarding-company-finish/onboarding-company-finish.component';
import { OnboardingCompanyHeaderComponent } from './components/onboarding-company-header/onboarding-company-header.component';
import { OnboardingCompanyHomeComponent } from './components/onboarding-company-home/onboarding-company-home.component';
import { OnboardingCompanyProfessionalDetailsComponent } from './components/onboarding-company-professional-details/onboarding-company-professional-details.component';
import { OnboardingCompanyProgressbarStepsComponent } from './components/onboarding-company-progressbar-steps/onboarding-company-progressbar-steps.component';
import { OnboardingCompanyReviewComponent } from './components/onboarding-company-review/onboarding-company-review.component';
import { OnboardingCompanyContactsStepsComponent } from './components/onboarding-company-contacts-steps/onboarding-company-contacts-steps.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    OnboardingCompanyRoutingModule,
    SharedUiStorybookModule,
    SkeletonModule,
    SelectModule,
    ComponentsModule,
  ],
  declarations: [
    OnboardingCompanyComponent,
    OnboardingCompanyHomeComponent,
    OnboardingCompanyHeaderComponent,
    OnboardingCompanyProgressbarStepsComponent,
    OnboardingCompanyContactsStepsComponent,
    OnboardingCompanyProfessionalDetailsComponent,
    OnboardingCompanyCompanyContactsComponent,
    OnboardingCompanyBillingComponent,
    OnboardingCompanyReviewComponent,
    OnboardingCompanyFinishComponent,
  ],
})
export class OnboardingCompanyModule {}
